import { cn } from "@/lib/utils";
import { ExtensionLink } from "components/core/ExtensionLink";
import { AppPage } from "models/AppPage";

interface DropdownListLayoutProps {
    children: AppPage[];
}

/**
 * Single-column list layout for standard dropdown menus
 * Used for navigation items that don't need grid layout
 */
export const DropdownListLayout = ({ children }: DropdownListLayoutProps) => {
    return (
        <div className="flex flex-col gap-1.5 pt-4">
            {children.map((child, childIndex) => (
                <ExtensionLink
                    key={`${child.label}-${childIndex}`}
                    href={child.href}
                    className="group/item relative overflow-hidden"
                    style={{
                        animation: `fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) ${childIndex * 0.05}s backwards`
                    }}
                >
                    <div
                        className={cn(
                            `relative px-4 py-2.5 text-sm font-medium
                            text-white`,
                            "rounded-lg transition-all duration-300 ease-out",
                            `hover:translate-x-1 hover:bg-white/15
                            hover:shadow-md`,
                            `before:absolute before:left-0 before:top-1/2
                            before:-translate-y-1/2`,
                            `before:h-0 before:w-0.5 before:rounded-full
                            before:bg-white`,
                            "before:transition-all before:duration-300",
                            "hover:before:h-3/4"
                        )}
                    >
                        <span className="relative z-10 block">
                            {child.label}
                        </span>
                    </div>
                </ExtensionLink>
            ))}
        </div>
    );
};
